export const RequestPushMsg = async (token, data) => {
  if (!token) return;

  try {
    if (token.startsWith('ExponentPushToken') || token.startsWith('ExpoPushToken')) {
      await fetch('https://exp.host/--/api/v2/push/send', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: token,
          title: data.title || 'Minas Car',
          body: data.msg || '',
          data: data.params || {}
        })
      });
    }
  } catch (error) {
    console.warn('[RequestPushMsg] Push error:', error);
  }
};